import { assertNonNullable } from '@rauschma/helpers/typescript/type.js';
import { type ComponentChildren } from 'preact';
import { useContext } from 'preact/hooks';
import { PageInfoContext } from '../core/page-info.js';

interface SiteLinkProps {
  href: string;
  children: ComponentChildren;
  
  classes?: Array<string>;
}

export function SiteLink(props: SiteLinkProps) {
  const {href, children, classes=[],  ...rest} = props;

  const pageInfo = useContext(PageInfoContext);
  assertNonNullable(pageInfo);

  if (href === pageInfo.pageAbsWebPath) {
    classes.push('link-to-current-page');
  }
  const classValue = classes.length > 0 ? classes.join(' ') : undefined;

  const peerWebPath = pageInfo.createPeerWebPath(href);
  return <a class={classValue} href={peerWebPath} {...rest}>{children}</a>;
}